export enum SubmissionTypes {
  Common = 'common',
  Own = 'own',
  All = 'all',
  Private = 'private',
}

export enum SubmissionSortEnum {
  createdAt_ASC = 'submission.createdAt',
  createdAt_DESC = '-submission.createdAt',
  submissionTitle_ASC = 'submission.title',
  submissionTitle_DESC = '-submission.title',
  isSample_ASC = 'submission.isSample',
  isSample_DESC = '-submission.isSample',
}
